import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_methods: {
    delivery: 'Dostawa',
    pickup: 'Odbiór',
  },
  asap: 'ASAP',
  unavailable: 'Niedostępne',
  ready_in_time: 'Gotowe za {{time}} min',
  locations: {
    [ORDER_METHODS.DELIVERY]: 'Dostawa do {{address}}',
    [ORDER_METHODS.PICKUP]: 'Odbiór w {{address}}',
  },
  buttons: {
    change: 'Zmień',
    see_hours: 'Zobacz godziny',
    change_location: 'Zmień lokalizację',
    change_time: 'Zmień godzinę',
  },
};
